import { useMemo } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { UtmBreakdownItem } from '../../types';
import { formatNumber } from '../../constants/nginx-sites';

interface AdsCampaignsTableProps {
  utmBreakdown: UtmBreakdownItem[];
}

export function AdsCampaignsTable({ utmBreakdown }: AdsCampaignsTableProps) {
  const sorted = useMemo(
    () => [...utmBreakdown].sort((a, b) => (b.visitors ?? b.count) - (a.visitors ?? a.count)),
    [utmBreakdown]
  );

  const totalVisitors = useMemo(
    () => sorted.reduce((sum, item) => sum + (item.visitors ?? 0), 0),
    [sorted]
  );

  const hasData = sorted.length > 0 && sorted.some((item) => item.campaign !== '(not set)');

  return (
    <Card>
      <CardHeader>
        <CardTitle>Campanhas UTM</CardTitle>
      </CardHeader>
      <CardContent>
        {!hasData ? (
          <div className="py-6 text-center text-sm text-muted-foreground">
            Nenhum tráfego com parâmetros UTM detectado no período selecionado.
            <br />
            <span className="text-xs mt-1 block">
              Configure parâmetros UTM (utm_source, utm_medium, utm_campaign) nos seus links para rastrear campanhas.
            </span>
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Source</TableHead>
                <TableHead>Medium</TableHead>
                <TableHead>Campaign</TableHead>
                <TableHead className="text-right">Visitantes</TableHead>
                <TableHead className="text-right">Requisições</TableHead>
                <TableHead className="text-right">%</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {sorted.map((item) => {
                const visitors = item.visitors ?? 0;
                const pct = totalVisitors > 0 ? ((visitors / totalVisitors) * 100).toFixed(1) : '0.0';
                return (
                  <TableRow key={`${item.source}|${item.medium}|${item.campaign}`}>
                    <TableCell className="font-mono text-xs">{item.source}</TableCell>
                    <TableCell className="font-mono text-xs">{item.medium}</TableCell>
                    <TableCell className="font-mono text-xs">{item.campaign}</TableCell>
                    <TableCell className="text-right font-semibold">{formatNumber(visitors)}</TableCell>
                    <TableCell className="text-right text-muted-foreground text-sm">
                      {formatNumber(item.count)}
                    </TableCell>
                    <TableCell className="text-right text-sm text-muted-foreground">{pct}%</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
